import React from 'react'
import { X } from 'lucide-react'
import type { TechnicalSpecificationState } from '../../../../../services/projectAutofillDraftService.ts'
import ModalOverlay from '../../../../UI/ModalOverlay/ModalOverlay.tsx'
import TechnicalSpecEditor from './TechnicalSpecEditor/TechnicalSpecEditor.tsx'
import styles from './BudgetSheetFullscreenModal.module.scss'

type Props = {
  isOpen: boolean
  onClose: () => void
  rubroTitle: string
  state: TechnicalSpecificationState | undefined | null
  onChange: (next: TechnicalSpecificationState) => void
  disabled: boolean
}

const TechnicalSpecFullscreenModal: React.FC<Props> = ({
  isOpen,
  onClose,
  rubroTitle,
  state,
  onChange,
  disabled
}) => {
  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose} zIndex={80}>
      <div className={styles.shell}>
        <header className={styles.header}>
          <div className={styles.titleBlock}>
            <h2 className={styles.title}>Especificaciones técnicas</h2>
            {rubroTitle ? <p className={styles.subtitle}>{rubroTitle}</p> : null}
          </div>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Cerrar especificaciones técnicas">
            <X size={22} strokeWidth={2} aria-hidden />
          </button>
        </header>
        {state ? (
          <div className={`${styles.body} ${styles.bodyDocked}`}>
            <TechnicalSpecEditor state={state} onChange={onChange} disabled={disabled} />
          </div>
        ) : (
          <div className={styles.emptyBody}>No hay especificaciones técnicas para mostrar.</div>
        )}
      </div>
    </ModalOverlay>
  )
}

export default TechnicalSpecFullscreenModal
